@if ((currentView$ | async); as currentView) {
  <filter-view-layout
    id="folder-view-container"
    #folderContainer>
    <div class="filter-bar" filter-view-filter-bar [hidden]="dataSourceZeroState.hasZeroState && dataSourceZeroState.errorCode !== 0">
      <div [formGroup]="form">
        <div class="filter-container">
          <mat-form-field goSelect>
            <mat-label>{{ 'common_filter-by' | translate}}</mat-label>
            <mat-select
              formControlName="filterBy"
              disableOptionCentering
              panelClass="offsetPanel">
              @for (option of filterOptions; track option) {
                <mat-option
                  [value]="option">
                  {{ filterTranslations[option] | translate }}
                </mat-option>
              }
            </mat-select>
            <mat-icon matIconSuffix class="ficon-app-chevron-down"></mat-icon>
          </mat-form-field>
        </div>
        <div class="sort-container">
          <mat-form-field goSelect>
            <mat-label>{{ 'common_sort-by' | translate }}</mat-label>
            <mat-select
              formControlName="sortBy"
              disableOptionCentering
              panelClass="offsetPanel">
              @for (option of sortByOptions; track option) {
                <mat-option
                  [value]="option">
                  {{ sortOrderTranslations[option] | translate }}
                </mat-option>
              }
            </mat-select>
            <mat-icon matIconSuffix class="ficon-app-chevron-down"></mat-icon>
          </mat-form-field>
          @if (showReorderActivities$ | async) {
            <button
              type="button"
              class="btn-none reorder-btn"
              [matTooltip]="'folder_view-reorder-activities' | translate"
              matTooltipPosition="above"
              (click)="sortActivities()">
              <i class="ficon-cog"></i>
            </button>
          }
        </div>
      </div>
    </div>
    <div class="filter-option" filter-view-options-bar [hidden]="dataSourceZeroState.hasZeroState">
     @if ((activityListDataSource.results$ | async)?.length) {
      <toggle-grid-list-view></toggle-grid-list-view>
     }
    </div>
    @if (!dataSourceZeroState.hasZeroState && !dataSourceZeroState.isLoading) {
      <div class="filter-content"
        filter-view-content
        (contextmenu)="openMenu($event)">
        @if ((activityListDataSource.results$ | async)?.length !== 0) {
          @if (currentView === views.GRID) {
            <div class="grid-view">
              <activity-grid-view></activity-grid-view>
            </div>
          }
          @if (currentView === views.LIST) {
            <div class="list-view">
              <activity-table-view (goToActivity)="goToActivity($event)"></activity-table-view>
            </div>
          }
        } @else {
          <folder-zero-state
            (openAssignmentSourceModal)="openAssignmentSourceModal()"
            (openInvite)="openInviteModal()"
            [hasInstructorRoleOrAbove]="hasInstructorRoleOrAbove()"
          ></folder-zero-state>
        }
        @if (hasInstructorRoleOrAbove() && (canCreateActivity$$ | async)) {
          <menu>
            <course-context-menu
              [canCreateActivity]="canCreateActivity$$ | async"
              [canReorderActivities]="canReorderActivities$ | async"
              (onInvite)="openInviteModal()"
              (onCreateActivity)="openAssignmentSourceModal()"
              (onSortActivities)="sortActivities()">
            </course-context-menu>
          </menu>
        }
      </div>
    }
    <!-- Datasource zero state -->
    <div class="filter-zero-state" filter-view-content [hidden]="!dataSourceZeroState.hasZeroState && !dataSourceZeroState.isLoading">
      <data-source-zero-state [dataSource]="activityListDataSource" (zeroStateChanged)="zeroStateChanged($event)"></data-source-zero-state>
    </div>
    <div class="filter-action" filter-view-action-bar [hidden]="dataSourceZeroState.hasZeroState">
      @if (!isLti() && shouldShowFooterButtons$ | async) {
        <button
          class="secondary-btn invite-btn"
          (click)="openInviteModal()"
          translate>
          common_invite
        </button>
      }
      <span
        [tabindex]="(canCreateActivity$$ | async) ? -1 : 0"
        [matTooltip]="getActivityCreationDisabledMessage$$ | async"
        [matTooltipDisabled]="canCreateActivity$$ | async"
        [attr.aria-disabled]="(canCreateActivity$$ | async) === false"
        matTooltipPosition="above"
        [attr.role]="(canCreateActivity$$ | async) === false ? 'button' : ''">
        @if (shouldShowFooterButtons$ | async) {
          <button
            data-cy="create-assignment"
            class="btn primary-btn create-btn"
            (click)="openAssignmentSourceModal()"
            [disabled]="(isCreating$ | async) || (canCreateActivity$$ | async) === false"
            [attr.aria-hidden]="(isCreating$ | async) || (canCreateActivity$$ | async) === false"
            translate>
            folder_view-create_button
            @if (isCreating$ | async) {
              <i class="ficon-spinner ficon-spin" aria-live="polite" attr.aria-label="{{'common_loading'| translate}}"></i>
            }
          </button>
        }
      </span>
    </div>
  </filter-view-layout>
}
